import React, { FunctionComponent } from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import serviceSectionAccordionContentStyles from './ServiceSectionAccordionContentStyles';
import IServicePlan from '../../../../../model/IServicePlan';
import ServicePlanItem from '../servicePlanItem/ServicePlanItem';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IServiceSectionAccordionContentProps {
  servicePlanListItems: Record<string, IServicePlan>;
  onClick: (servicePlanId: string) => void;
  selectedServicePlan: string;
}

const ServiceSectionAccordionContent: FunctionComponent<IServiceSectionAccordionContentProps> = ({
  servicePlanListItems,
  onClick,
  selectedServicePlan,
}) => {
  const styles = serviceSectionAccordionContentStyles();

  return (
    <Box display="flex" flexDirection="column" data-test="customise:servicePlanSectionContent">
      <Typography variant="body1" className={styles.serviceDescription}>
        <Translation id="spc.customise.serviceSection.description" />
      </Typography>
      <Link
        className={styles.showFeaturesLink}
        href="https://www.subaru.com.au/service/plans"
        target="_blank"
        data-test="customise:servicePlanFeaturesLink"
      >
        <Translation id="spc.customise.serviceSection.showFeatures" />
      </Link>
      {Object.keys(servicePlanListItems).map(key => (
        <Box mb={3} key={key}>
          <ServicePlanItem
            servicePlanId={key}
            name={servicePlanListItems[key].name}
            prices={servicePlanListItems[key].prices}
            serviceIntervals={servicePlanListItems[key].serviceIntervals}
            selected={selectedServicePlan && selectedServicePlan.toLowerCase() === key.toLowerCase()}
            onClick={onClick}
          />
        </Box>
      ))}
    </Box>
  );
};

export default ServiceSectionAccordionContent;
